const host = window.location.host;
const protocol = window.location.protocol + "//";
export default {
  // BASE_URL: protocol+host+"/fasiculus/api/",
  BASE_URL: "https://funqid.com/rvm/api/",
  // BASE_URL: "http://localhost:8090/fasiculus/api/",
  // LOGOUT: "http://localhost:8080/fasiculus/logout",
  // IMAGE_BASE_URl: protocol+host+"/image/",
  IMAGE_BASE_URl: "https://funqid.com/image/",
  VIDEO_BASE_URL: "https://funqid.com/user_image/",
  // IMAGE_BASE_URl:"http://localhost:8082/rvm/image/"
};
